import { module } from "angular";
import { ActionMenuComponent } from "./ActionMenuComponent";

module("mmGui").component("irActionMenu", new ActionMenuComponent());
